import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/** Admin-configurable marketing imagery (site_settings table). */
export type SiteImageSlot = "hero" | "quote_band";

export type SiteImage = {
  url: string;
  alt: string;
};

export const SITE_IMAGE_DEFAULTS: Record<SiteImageSlot, SiteImage> = {
  hero: { url: "/img/signing.jpg", alt: "Attorney signing a legal document" },
  quote_band: { url: "/img/reading-room.jpg", alt: "Law library shelves in warm light" },
};

const SETTINGS_KEY = "site_images";

export function useSiteImages() {
  const { data } = useQuery({
    queryKey: ["site-images"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_public_site_setting", {
        _key: SETTINGS_KEY,
      });
      if (error) throw error;
      return (data ?? null) as Partial<Record<SiteImageSlot, SiteImage>> | null;
    },
    staleTime: 5 * 60 * 1000,
  });

  const images: Record<SiteImageSlot, SiteImage> = {
    hero: data?.hero?.url ? data.hero : SITE_IMAGE_DEFAULTS.hero,
    quote_band: data?.quote_band?.url ? data.quote_band : SITE_IMAGE_DEFAULTS.quote_band,
  };

  return { images };
}

export { SETTINGS_KEY as SITE_IMAGES_SETTINGS_KEY };
